import api from './api';

export interface ServiceDto {
  id: string;
  name: string;
  description?: string;
  isActive: boolean;
  isComingSoon: boolean;
}

export async function getActiveServices(): Promise<ServiceDto[]> {
  try {
    const res = await api.get('/services/active');
    return res.data?.data || [];
  } catch (e) {
    return [];
  }
}
